module.exports = __webpack_public_path__ + "img/img_manyou.7d99f442.png";